import * as React from 'react'

function ArrowDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={12} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M.287.6C.5.282.815.07 1.164.015c.35-.056.705.046.988.285l9.856 8.397L21.864.3c.282-.239.638-.341.987-.285.35.056.666.267.878.585.109.158.188.34.234.533a1.682 1.682 0 01-.145 1.156 1.451 1.451 0 01-.356.44l-10.415 8.877a1.597 1.597 0 01-1.04.394c-.374 0-.74-.138-1.038-.394L.554 2.73a1.45 1.45 0 01-.357-.44 1.683 1.683 0 01-.145-1.156C.099.94.179.758.288.6z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ArrowDownIcon
